import { getVocabulary } from "components/Vocabulary";
import { ASSET_EVENTS_MAP } from "utils/assetUtils";

const useAssetEventDisplayList = () => {
  return {
    [ASSET_EVENTS_MAP.TAGS_UPDATE]: "Tags Updated",
    [ASSET_EVENTS_MAP.ACTIVE_UPDATE]: "Status Updated",
    [ASSET_EVENTS_MAP.NAME_UPDATE]: "Name Updated",
    [ASSET_EVENTS_MAP.SUB_PRODUCT_UPDATE]: `${getVocabulary("subProduct")} Updated`,
    [ASSET_EVENTS_MAP.OWNER_UPDATE]: "Owner Updated",
    [ASSET_EVENTS_MAP.LOCATION_UPDATE]: "Location Updated",
    [ASSET_EVENTS_MAP.MAC_ADDRESS_UPDATE]: "MAC Address Updated",
    [ASSET_EVENTS_MAP.ARN_UPDATE]: "ARN Updated",
    [ASSET_EVENTS_MAP.CLOUD_ACCOUNT_ID_UPDATE]: "Cloud Account ID Updated",
    [ASSET_EVENTS_MAP.IPV4_UPDATE]: "IPV4 Updated",
    [ASSET_EVENTS_MAP.IPV6_UPDATE]: "IPV6 Updated",
    [ASSET_EVENTS_MAP.HOSTNAME_UPDATE]: "Host Name Updated",
    [ASSET_EVENTS_MAP.OS_VERSION_UPDATE]: "OS Version Updated",
    [ASSET_EVENTS_MAP.OS_UPDATE]: "OS Updated",
    [ASSET_EVENTS_MAP.CLOUD_PROVIDER_UPDATE]: "Cloud Provider Updated",
    [ASSET_EVENTS_MAP.DNS_NAME_UPDATE]: "DNS Name Updated",
    [ASSET_EVENTS_MAP.PRODUCT_UPDATE]: `${getVocabulary("product")} Updated`,
    [ASSET_EVENTS_MAP.ENVIRONMENT_UPDATE]: `Environment Updated`,
    [ASSET_EVENTS_MAP.CORRELATED_ASSET_FOUND]: "Correlated Asset Found",
    [ASSET_EVENTS_MAP.ASSET_DELETED]: "Asset Deleted",
    [ASSET_EVENTS_MAP.ASSET_REAPPEARED]: "Asset Reappeared",
    [ASSET_EVENTS_MAP.ASSET_CREATED_FROM_FINDINGS]: "Asset Created",
    [ASSET_EVENTS_MAP.IMAGE_VERSION_ADDED]: "New image version found",
    [ASSET_EVENTS_MAP.TOOL_TYPE_UPDATE]: "ToolType Updated",
    [ASSET_EVENTS_MAP.SERIAL_NUMBER_UPDATE]: "Serial Number Updated",
    [ASSET_EVENTS_MAP.FQDN_UPDATE]: "FQDN Updated",
    [ASSET_EVENTS_MAP.CLOUD_RESOURCE_ID_UPDATE]: "Cloud Resource ID Updated",
  };
};

export default useAssetEventDisplayList;
